module["exports"] = [
  "com",
  "info",
  "name",
  "net",
  "org",
  "de",
  "ch",
  "at"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/internet/domain_suffix.js
// module id = 618
// module chunks = 0